"use client";

import { usePathname } from "next/navigation";
import { useLayoutEffect } from "react";

import { notifyRouteCommit } from "@/lib/view-transitions/page-transition";

// =============================================================================

/**
 * Reports each route commit to the page transition controller, which waits
 * for the new page to be rendered before letting the transition go on.
 */
export function RouteWatcher() {
  const pathname = usePathname();

  // Before paint, so the controller sees the new route at once
  useLayoutEffect(() => {
    notifyRouteCommit(pathname);
  }, [pathname]);

  return null;
}

// =============================================================================
